import React, { Fragment, useState, useEffect } from "react";
import {
  List,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Grid,
  Typography,
  Chip,
  Divider,
  Tooltip,
  Avatar,
} from "@mui/material";
import moment from "moment";
import formatName from "reuseableTable/naming-convention";

const ConnectionList = ({
  users,
  setUser,
  searchTerm,
  setRoomId,
  generateUniqueId,
  handleRoomChange,
}) => {
  const [orderedUsers, setOrderedUsers] = useState([]);

  const getInitial = (name) => {
    return name?.charAt(0)?.toUpperCase() || "?";
  };
  const stringToColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = hash % 360;
    return `hsl(${h}, 70%, 80%)`;
  }
  useEffect(() => {
    const filtered = users.filter((user) =>
      formatName(user?.connectionName)
        .toLowerCase()
        .includes(searchTerm.trim().toLowerCase())
    );

    setOrderedUsers(filtered);
  }, [users, searchTerm]);

  return (
    <List component="nav">
      {orderedUsers.map((user) => {
        const userMessageCount =
          user?.messageCount?.[localStorage.getItem("userId")] || 0;

        return (
          <Fragment key={user.id}>
            <ListItemButton
              onClick={() => {
                if (user?.connectionType === "Friend") {
                  const id = generateUniqueId(
                    localStorage.getItem("userId"),
                    user?.connectionId
                  );
                  handleRoomChange(user?.connectionId);
                } else {
                  setRoomId(user?.connectionId);
                  handleRoomChange(user?.connectionId);
                }
                setUser(user);
              }}
              sx={{
                borderRadius: 2,
                padding: "8px 12px",
                backgroundColor: "#fff",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <Tooltip title={formatName(user?.connectionName)}>
                <ListItemAvatar>
                  <Avatar
                    alt={user?.connectionName}
                    src={user?.image?.data ? `data:image/*;base64, ${user?.image?.data}` : undefined}
                    sx={{
                      width: 42,
                      height: 42,
                      mr: 1.5,
                      bgcolor: stringToColor(user?.connectionName),
                      color: "#333",
                      fontWeight: 600,
                      border: user?.image?.data
                        ? "none"
                        : `2px solid hsl(${(() => {
                          let hash = 0;
                          const name = user?.connectionName || "";
                          for (let i = 0; i < name.length; i++) {
                            hash = name.charCodeAt(i) + ((hash << 5) - hash);
                          }
                          return hash % 360;
                        })()}, 70%, 60%)`,
                    }}
                  >
                    {!user?.image?.data && getInitial(user?.connectionName)}
                  </Avatar>
                </ListItemAvatar>
              </Tooltip>

              <ListItemText
                primary={
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item xs zeroMinWidth>
                      <Typography
                        variant="body1"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {formatName(user?.connectionName)}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: "text.secondary" }}
                      >
                        {moment(user?.lastMessageTimeStamp).format("h:mm A")}
                      </Typography>
                    </Grid>
                  </Grid>
                }
                secondary={
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item xs></Grid>
                    <Grid item>
                      {userMessageCount !== 0 && (
                        <Chip
                          label={userMessageCount}
                          color="secondary"
                          sx={{
                            height: 24,
                            fontSize: "0.8rem",
                            fontWeight: "bold",
                          }}
                        />
                      )}
                    </Grid>
                  </Grid>
                }
              />
            </ListItemButton>
            <Divider sx={{ margin: "8px 0" }} />
          </Fragment>
        );
      })}
    </List>
  );
};

export default ConnectionList;
